// extracted by mini-css-extract-plugin
module.exports = {"postsListContainer":"post-card-list-module--postsListContainer--1Nj7U","postListItem":"post-card-list-module--postListItem--1N_DS"};